import { useEffect } from "react";

const DEFAULT_TITLE = "Soonyoung — Buy Cosmetics & Beauty Products Online in India";
const DEFAULT_DESC =
  "Shop original cosmetics & beauty products online at best prices in India — skincare, makeup, hair & body care from leading Indian and international brands. Free delivery over ₹999, all India.";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function useSeo({ title, description, image, path, noindex = false, jsonLd } = {}) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const origin = window.location.origin;
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    const img = image ? (image.startsWith("http") ? image : `${origin}${image}`) : `${origin}/assets/og-cover.png`;
    const url = `${origin}${path ?? `${window.location.pathname}${window.location.search}`}`;

    document.title = t;
    setMeta("name", "description", d);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:image", img);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", t);
    setMeta("name", "twitter:description", d);
    setMeta("name", "twitter:image", img);
    setCanonical(url);

    let tag = document.getElementById("seo-jsonld-page");
    if (jsonLdStr) {
      if (!tag) {
        tag = document.createElement("script");
        tag.id = "seo-jsonld-page";
        tag.type = "application/ld+json";
        document.head.appendChild(tag);
      }
      tag.textContent = jsonLdStr;
    } else if (tag) {
      tag.remove();
    }
  }, [title, description, image, path, noindex, jsonLdStr]);
}
